/* @flow */

import React from 'react';
import { Message, Icon } from 'semantic-ui-react';

export const NoMessage = () => (
  <Message icon attached="top">
    <Icon name="send" />
    <Message.Content>
      <Message.Header>Aucun message dans cette conversation</Message.Header>
    </Message.Content>
  </Message>
);



// WEBPACK FOOTER //
// ./src/modules/messaging/components/messages/NoMessage.js